import { lazy, Suspense, useEffect } from 'react';

/// Components
import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import {  Route, Switch, withRouter } from 'react-router-dom';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./vendor/swiper/css/swiper-bundle.min.css";
import "./css/style.css";
import "leaflet/dist/leaflet.css";

//import {NavMenuToggle} from './jsx/layouts/nav/NavHader';

const Terminos = lazy(() => import('./jsx/pages/Terminos'));
const TerminosApp = lazy(() => import('./jsx/pages/TerminosApp'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const Login = lazy(() => {
    return new Promise(resolve => {
    setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
  });
});


// export const SideBarOverlay=()=>{
//     let toggleOverLay = document.querySelector(".sidebar-close")
//     //console.log(toggleOverLay);
//     if(toggleOverLay.classList.contains('menu-toggle')){
//         toggleOverLay.classList.remove('menu-toggle');
//     }else{
//         toggleOverLay.classList.add("menu-toggle");
//     }
// }  

function App (props) {
    const dispatch = useDispatch();
    useEffect(() => {
     
       if (window.location.pathname !== "/terminos" && window.location.pathname !== "/terminos-app")
       {
        checkAutoLogin(dispatch, props.history);
       }
       
    }, [dispatch, props.history]);
    
    
    let routes = (  
        <Switch>
            <Route path='/login' component={Login} />
            <Route path='/terminos' component={Terminos} />
            <Route path='/page-forgot-password' component={ForgotPassword} />
            <Route path='/terminos-app' component={TerminosApp} />
        </Switch>
    );
    if (props.isAuthenticated) {
		return (
			<>
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>  
                   }
                >
                    <Index />
                </Suspense>
            </>
        );
	
	}else{
		return (
			<div className="vh-100">
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                  }
                >   
              
                    {routes}
                </Suspense>
			</div>
		);
	}
};

const mapStateToProps = (state) => {
  
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App)); 

